// import isEmpty  from 'lodash/isEmpty';
import  { prtStart, prtEnd, prtInput, prtMsg, prtStep, prtVar, prtOutput, prtErr } from "../utils/prt"; 

let trace = true;
let compName = 'picapp'

const initialState = {
        filters: { eventListFilter: 'All My Events' },
        messageBoardId: ''
}

export default (state = initialState, action = {}) => {

    //trace && prtStart(compName, 'reducer')
    //trace && prtInput('action', JSON.stringify(action,null,2));
    //trace && prtInput('state', JSON.stringify(state,null,2));

    // when user logs in, we set uid on the state object.
    switch (action.type) {
        case 'PIC_APP_ERROR':  /* logs app errors to redux store */
        return Object.assign({}, state, { 
                error: action.error
            })
        case 'CLEAR_PIC_APP_ERROR':  
            return Object.assign({}, state, {
                error: ''
            })
        case 'POST_COMPONENT_STATUS':  
            return Object.assign({}, state, {
                status: action.status
            })
        case 'SET_APP_DIRECTIVE':  
            return Object.assign({}, state, { 
                directive: action.directive
            })
        case 'UPDATE_EVENT_LIST_FILTER':  
            //trace && prtMsg("Inside UPDATE_EVENT_LIST_FILTER case statement");
            //trace && prtVar("action.filters", JSON.stringify(action.filters, null,2));
            return Object.assign({}, state, { 
                filters: action.filters
            })
        default:
            return state;
    }
};




// WEBPACK FOOTER //
// ./src/reducers/picapp.js